import { render, staticRenderFns } from "./PremiumAmount.vue?vue&type=template&id=51a38da5&scoped=true&"
import script from "./PremiumAmount.vue?vue&type=script&lang=js&"
export * from "./PremiumAmount.vue?vue&type=script&lang=js&"
import style0 from "./PremiumAmount.vue?vue&type=style&index=0&id=51a38da5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a38da5",
  null
  
)

export default component.exports